interface Chef {
  id: string | number
  firstName: string
  lastName: string
  profileImageUrl?: string
  bannerPic?: string
  description?: string
  logoPic?: string
}

interface NutritionInfo {
  calories: number
  servingSize: string
  fat: number
  carbs: number
  fiber: number
  protein: number
  sodium: number
  saturatedFat: number
  sugar: number
}

interface Promotion {
  amount: {
    value: number
    type: string
  }
  type: string
  constraints: {
    categoryId?: number
    subCategoryId?: number
    capAmount?: {
      type: string
      value: number
    }
  }
}

interface Media {
  detailsImage?: string
  detailsImageMobile?: string
  secondaryImage?: string
}

interface SpecificationDetail {
  id: number
  label: string
  image?: string
}

interface Warning {
  message: string
  restrictionsApplied?: Array<{ name: string }>
  dietsNotMatching?: Array<{ name: string }>
  allergensNotMatching?: Array<{ name: string }>
}

interface BaseTag {
  label: string
  color: string
  type?: string
}

interface WeightTag extends BaseTag {
  weight: string
  icon?: never
}

interface IconTag extends BaseTag {
  icon: React.ReactNode
  weight?: never
}

type Tag = WeightTag | IconTag

interface Allergen {
  id: number
  label: string
  name: string
}

interface Ingredient {
  id: number
  parentId: number | null
  name: string
  value: string
}

interface Specification {
  id: number
  label: string
  image?: string
  image_png?: string
}

interface Characteristic {
  text: string
  textColor: string
  type: string
}

interface Nutrient {
  id: number
  name: string
  unit: string
  value: number | string
  dv: string
  dailyValue?: string
}

interface NutritionalInfo {
  fat: string
  carbs: string
  fiber: string
  sugar: string
  sodium: string
  protein: string
  calories: string
  nutrients: Nutrient[]
  servingSize: string
  saturatedFat: string
  servingsPerPackage: string
}

interface Chef {
  id: string | number
  firstname: string
  lastname: string
  isCelebrity: boolean
  logopic?: string
  image?: string
}

interface Cart {
  quantity: number
}

interface Section {
  quickFilterId: number
  sectionId: number
  subSectionId: number
}

interface CartChef {
  id: number
  name: string
  images: string[]
}

interface SpecificationDetail {
  id: number
  label: string
  image?: string
  image_png?: string
}

interface TagLevel {
  text?: string
  textColor: string
  icon?: string
  backgroundColor?: string
  tooltip?: string
  type: string
  coreUXTextColor?: string
  coreUXBackgroundColor?: string
}

export enum EntityType {
  BUNDLE = 'BUNDLE',
  MEAL = 'MEAL',
  WINE = 'WINE',
  WINE_BUNDLE = 'WINE_BUNDLE'
}

export type ProductCartItem = {
  type: EntityType
  inventoryId: string
  properties: Meal
}

interface MealTag {
  type: string
  name: string
  [key: string]: string
}

export interface Meal {
  allergens: Allergen[]
  all_tags?: MealTag[]
  batchId: number
  calories: number
  cart?: Cart
  cartChef?: CartChef
  cartTags?: any[]
  category: string
  categoryId: number
  characteristics?: Characteristic[]
  chef?: Chef
  chef_firstname?: string
  chef_id?: number
  chef_lastname?: string
  cuisines: string[]
  description: string
  entityType: string
  filterBy: string[]
  finalPrice?: number
  full_path_chef_image?: string
  heatInstructionsMicrowave: string
  heatInstructionsOven: string
  id: number
  isNewMeal?: boolean
  isUnityPass?: boolean
  hasRecipe?: boolean
  isMealRestaurantExclusive?: boolean
  sidesSubCategoryNames?: string | string[]
  isBackInTheMenu?: boolean
  image: string
  imageUrl?: string
  ingredients: Ingredient[]
  inStock: boolean
  inventoryId: string
  isCelebrity?: boolean
  isExtra: boolean
  isFavorite: boolean
  isFreePremiumMeal?: boolean
  isPremiumMeal: boolean
  isExclusiveMembershipProduct?: boolean
  media?: Media
  meatType?: string
  name: string
  nutritionalFacts?: NutritionInfo
  nutritionalInfo?: NutritionalInfo
  magento_id?: number
  membershipPremiumDiscount?: number
  membershipAddAndSaveDiscount?: number
  premiumFee: number
  premium_fee?: number
  premium_special?: boolean
  price: number
  prices: null | unknown[]
  promotions?: Promotion[]
  publicUrl?: string
  qty?: number
  ratioCarb: string
  ratioFat: string
  ratioProtein: string
  reviewMadeByUser: any
  reviews: number
  sections: Section[]
  short_description?: string
  sku: string
  sortAndFilter?: object
  specifications: Specification[]
  specifications_detail: SpecificationDetail[]
  stars: number | null
  stock: number
  strikethroughPrice: null | number
  tags?: Tag[]
  tagsLevel1: TagLevel[]
  tagsLevel2: TagLevel[]
  tagsLevel3: TagLevel[]
  title?: string
  warning?: string
  warnings?: Warning
  wasAlreadyRequested: boolean
  weight: number
}
